import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {MDBModalRef, ModalDirective} from 'ng-uikit-pro-standard';
import { ChecklistsService } from '../../../../common/services/checklists.service';
import { Localization } from '../../../../common/enums/localization';
import { InputTextModalViewModel } from '../../../../common/model/input-text-modal.model';
import { ChecklistNode } from '../../checklist/model/checklist-node';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-update-node-modal',
  templateUrl: './add-update-node-modal.component.html',
  styleUrls: ['./add-update-node-modal.component.scss']
})
export class AddUpdateNodeModalComponent implements OnInit {

  public readonly Localization = Localization;
  public formGroup: UntypedFormGroup;
  public node: ChecklistNode;
  public item: any;
  public isSavingChanges: boolean = false;
  public currentBuildingId: number;
  public model: InputTextModalViewModel;
  public isUpdate: boolean;

  private readonly onSave = new EventEmitter<ChecklistNode|null>();

  public get labelFormControl(): UntypedFormControl { return this.formGroup.get('label') as UntypedFormControl; }

  constructor(
      private readonly checklistsService: ChecklistsService,
      private readonly route: ActivatedRoute,
      private readonly translate: TranslateService,
      private readonly self: MDBModalRef,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.currentBuildingId = parseInt(this.route.snapshot.params['bid'], 10);
    });
  }

  public createFor(parentNode: ChecklistNode, isSection: boolean) {
    this.isUpdate = false;
    this.mapModel(isSection, this.isUpdate);
    this.node = { parentId: parentNode.id } as ChecklistNode;
    this.initForm();
    return this.onSave.toPromise();
  }

  public show(node: ChecklistNode, isSection: boolean, isUpdate: boolean){
    // TODO: add images string when provided by Raymond
    this.isUpdate = isUpdate;
    this.mapModel(isSection, isUpdate);
    this.node = node;
    this.initForm();
    return this.onSave.toPromise();
  }

  public close(){
    this.formGroup.reset();
    this.onSave.emit(null);
    this.self.hide();
  }

  private mapModel(isSection: boolean, isUpdate: boolean){
    if(isSection){
      this.model = isUpdate ? this.mapSectionModel(this.translate.instant(Localization.EditSection)) : this.mapSectionModel(this.translate.instant(Localization.AddSection));
    }else{
      this.model = isUpdate ? this.mapGroupModel(this.translate.instant(Localization.EditGroup)) : this.mapGroupModel(this.translate.instant(Localization.AddGroup));
    }
  }

  private mapSectionModel(title: string): InputTextModalViewModel{
    return {
      title: title,
      control: this.translate.instant(Localization.Section),
      image: 'checklist',
      label: this.translate.instant(Localization.Section),
      tooltip: this.translate.instant(Localization.AddSectionTooltip),
      placeholder: this.translate.instant(Localization.SectionLabel)
    } as InputTextModalViewModel
  }

  private mapGroupModel(title: string): InputTextModalViewModel{
    return {
      title: title,
      control: this.translate.instant(Localization.Group),
      image: 'checklist',
      label: this.translate.instant(Localization.Group),
      tooltip: this.translate.instant(Localization.AddGroupTooltip),
      placeholder: this.translate.instant(Localization.GroupLabel)
    } as InputTextModalViewModel
  }

  public onSubmit(){
    if (this.formGroup.invalid) {
      Object.values(this.formGroup.controls)
        .forEach(c => c.markAsTouched());
    } else {
      this.isUpdate ? this.updateNode() : this.createNewNode();
      this.onSave.emit(this.node);
    }
  }

  private createNewNode() {
    this.isSavingChanges = true;
    this.checklistsService.addNode(this.currentBuildingId, this.node.parentId, this.labelFormControl.value).subscribe((savedNode) => {
      this.node = savedNode;
      this.isSavingChanges = false;
      this.close();
    });
  } 

  private updateNode(){
    this.node.label = this.labelFormControl.value;
    this.isSavingChanges = true;
    this.checklistsService.updateNode(this.node, false).subscribe(() => {
      this.isSavingChanges = false;
      this.close();
    });
  }
  private initForm(){
    this.formGroup = new UntypedFormGroup({
      'label': new UntypedFormControl(this.isUpdate ? this.node.label : '', [Validators.required])
    });
  }

}
